import { createAsyncThunk } from '@reduxjs/toolkit';
import { SilentThunkError } from '@socialive/common';
import normalizeTraySolutionInstance from '../../../normalizers/traySolutionInstance';
import client from '../../../services/api-client';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectAvailableVendors, selectTrayAccountId, selectTrayUserToken } from '../selectors';

export default createAsyncThunk('connectionManager/fetchTraySolutionInstances', async ({ accountId }, { getState }) => {
  const state = getState();

  const apiBaseUrl = selectApiBaseUrl(state);
  const trayUserToken = selectTrayUserToken(state);
  const availableVendors = selectAvailableVendors(state);

  const url = `${apiBaseUrl}/workflows/get-solution-instances/${trayUserToken}`;

  const response = await client(url);
  const instanceEdges = response?.data?.viewer?.solutionInstances?.edges;
  const instances = instanceEdges.map(({ node }) => node);

  const normalizer = normalizeTraySolutionInstance(availableVendors);
  const solutionInstances = instances.map(normalizer);

  if (accountId !== selectTrayAccountId(getState())) {
    throw new SilentThunkError('trayAccountId changed during processing');
  }

  return solutionInstances;
});
